/* Publish by EComposer at 2026-10-15 11:28:22*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-6dy2vu4lykw"]=  window.__ectimmers["ecom-6dy2vu4lykw"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-6dy2vu4lykw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6dy2vu4lykw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-82m4zti8yrw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-82m4zti8yrw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sr0gfc2fc4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sr0gfc2fc4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wjcleotad0o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wjcleotad0o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nwtehtbc06').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nwtehtbc06', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k252hp8mffm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k252hp8mffm', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-zgpv4o0wms"]=  window.__ectimmers["ecom-zgpv4o0wms"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-zgpv4o0wms"]["1rqeifvb3"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let s=this.$el;if(!s)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let r=s.querySelector(".ecom-element.ecom-base-image"),a=s.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-zgpv4o0wms').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zgpv4o0wms', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bqktb86gxms').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bqktb86gxms', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}